import { render, staticRenderFns } from "./EntityLink.vue?vue&type=template&id=33e574e4&scoped=true"
import script from "./EntityLink.vue?vue&type=script&lang=js"
export * from "./EntityLink.vue?vue&type=script&lang=js"
import style0 from "./EntityLink.vue?vue&type=style&index=0&id=33e574e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e574e4",
  null
  
)

export default component.exports